/* ============================================================
   Sam's Store — Transparent Header JS (Phase D)
   Adds body.sam-header-scrolled when page scrollY > 80px.
   Homepage only — checks for body.template-index.
   ============================================================ */
(function () {
  'use strict';

  /* Only run on homepage */
  if (!document.body.classList.contains('template-index')) return;

  var scrollThreshold = 80;
  var body = document.body;
  var ticking = false;

  function updateHeader() {
    if (window.scrollY > scrollThreshold) {
      body.classList.add('sam-header-scrolled');
    } else {
      body.classList.remove('sam-header-scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  /* Run immediately in case page loads mid-scroll */
  updateHeader();
})();
